import script from "./IssuePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./IssuePanel.vue?vue&type=script&setup=true&lang=js"

import "./IssuePanel.vue?vue&type=style&index=0&id=f19d7882&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f19d7882"]])

export default __exports__